import { Component, OnInit } from "@angular/core";
import { Message } from "primeng/api";
import { environment } from "src/environments/environment";
import { AuthenticationService } from "src/app/services/authentication.service";
import { DashboardService } from "../services/dashboard.service";
import { CompanyService } from "../services/company.service";

@Component({
    selector: "app-dashboard",
    templateUrl: "./dashboard.component.html",
})
export class DashboardComponent implements OnInit {
    numSenriClients: number;
    numDistributors = -1;
    clientNumDistributors = 0;

    clientLoaded = false;
    constructor(
        private authService: AuthenticationService,
        private dashboardService: DashboardService,
        private companyService: CompanyService,
    ) {}

    messages: Message[] = [];
    organizationName = environment.organizationName;
    applicationName = environment.applicationName;

    clearMessages() {
        this.messages.length = 0;
    }

    setMessage(msg: Message) {
        this.clearMessages();
        this.messages.push(msg);
    }

    isAdmin() {
        return this.authService.isAdmin() || this.authService.isManager();
    }

    ngOnInit() {
        this.dashboardService.getSenriClients().subscribe((items) => {
            this.numSenriClients = items.length;
            this.numDistributors = 0;
            for (let index = 0; index < items.length; index++) {
                this.dashboardService
                    .getDistributors(items[index].id)
                    .subscribe((dists) => {
                        this.numDistributors += dists.length;
                    });
            }
        });

        this.companyService.activeCompanyId$.subscribe((id) => {
            if (id !== null) {
                this.dashboardService
                    .getDistributors(id)
                    .subscribe((records) => {
                        this.clientNumDistributors = records.length;
                        this.clientLoaded = true;
                    });
            }
        });
    }

    showView() {
        return (
            (this.authService.userProfile !== null &&
                this.numDistributors !== -1 &&
                this.numSenriClients !== undefined) ||
            (this.authService.userProfile !== null && this.clientLoaded)
        );
    }

    getName() {
        return this.authService.getClaims()["firstName"];
    }
}
